import { render, staticRenderFns } from "./CorrectPolyPhoneModal.vue?vue&type=template&id=3189d324&scoped=true"
import script from "./CorrectPolyPhoneModal.vue?vue&type=script&lang=js"
export * from "./CorrectPolyPhoneModal.vue?vue&type=script&lang=js"
import style0 from "./CorrectPolyPhoneModal.vue?vue&type=style&index=0&id=3189d324&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3189d324",
  null
  
)

export default component.exports